import { Component, OnInit, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TakeUntilDestroy } from '@app/shared/decorators/take-until-destroy.decorator';
import { LimitedTimeEvent } from '@app/shared/models/limitedTimeEvent.model';
import { Modal, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { ShopOffersItem } from '@app/shared/models/shop-offers.model';
import { LoggerService } from '@app/shared/services/logger.service';
import { EventManager } from '@app/shared/utils/event-manager';
import { Observable } from 'rxjs';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { SharedModule } from '@app/shared/shared.module';
import { NavigationButtonComponent } from '@app/shared/components/navigation-button/navigation-button.component';
import { EventsRepository } from '@app/shared/state/events/events.repository';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-progressbag-info-modal',
  templateUrl: './progressbag-info.component.html',
  styleUrls: ['./progressbag-info.component.scss'],
  standalone: true,
  imports: [ButtonComponent, NavigationButtonComponent, SharedModule],
})
export class ProgressbagInfoModalComponent implements OnInit {
  protected readonly progressbagInfoModalData = inject<Modal>(MAT_DIALOG_DATA);
  private eventManager = inject(EventManager);
  public logger = inject(LoggerService);
  private eventsRepo = inject(EventsRepository);

  componentDestroy: () => Observable<unknown>;

  progressbag = signal<LimitedTimeEvent | null>(null);
  progressbagShopItem = signal<ShopOffersItem | null>(null);
  progressbagMinPurchase = signal<string | null>(null);
  progressbagCurrencySymbol = signal<string | null>(null);

  ngOnInit(): void {
    const eventId = this.progressbagInfoModalData.data.eventId;
    const evt = this.eventsRepo.getEventById(eventId);

    this.progressbag.set(evt);
  }

  openInfo2(): void {
    this.closeModal();

    this.eventManager.openModal(
      new Modal(NonPersistedModalName.ProgressbagInfo2ModalComponent, ModalType.View, this.progressbag())
    );
  }

  closeModal(): void {
    this.eventManager.closeModal(
      new Modal(this.progressbagInfoModalData.id, ModalType.View, this.progressbagInfoModalData)
    );
  }
}
